/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'

export function Registration() {

  const [imageUrl,setImageUrl]=useState("");
  const [profilePicture, setProfilePicture] = useState();
  const [businessName,setBusinessName]=useState("");
  const [countryCode, setCountryCode] = useState('');
  const [mobileNumber,setMobileNumber]=useState("");
  const [phoneNumber,setPhoneNumber]=useState("");
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [confirmPassword,setConfirmPassword]=useState("");
  const [loading, setLoading] = useState(false)

  // set error state
  const [error,setError]=useState([{
    profilePicture:'',
    businessName:'',
    phoneNumber:'',
    email:'',
    address:'',
    password:'',
    confirmPassword:''
  }])

  // remove validation function
  const removeError = (err:any) =>{
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }


  const handleChange = (value:any, country:any,e:any,formate:any) => {

    setPhoneNumber(value);

    const parts = formate.split(' ');
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, "");
    setCountryCode(country.dialCode); // get country code
    setMobileNumber(formattedValue); // get mobile number without country code
    
  };

  const registrationApi = async () =>{
    
  }
  
  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])
  return (
    <div className='bg-body d-flex justify-content-center rounded-4 w-md-600px p-10 '>
      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_signup_form'
        // noValidate
      >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>Sign Up</h1>
          {/* end::Title */}

        </div>
      
        {/* <!--begin::Input group--> */}
        <div className="row mb-8">
            {/* <!--begin::Col--> */}
            <div className="col-lg-12">
                {/* <!--begin::Image input--> */}
                <div className="image-input image-input-outline " data-kt-image-input="true">

                    {/* <!--begin::Preview existing avatar--> */}
                    
                    <img alt='images' id="previewImage" className="image-input-wrapper w-125px h-125px changeimg pointer" src={profilePicture?URL.createObjectURL(profilePicture):imageUrl==="" || imageUrl===null?toAbsoluteUrl("/media/avatars/300-1.jpg"):imageUrl} /> 
                    
                    
                    {/* <!--end::Preview existing avatar--> */}
                    {/* <!--begin::Label--> */}
                    <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="" data-bs-original-title="Change avatar">
                        <i className="fa fa-edit"></i>
                        {/* <!--begin::Inputs--> */}
                        <input type="file" name="image" id="profileImage" accept=".png, .jpg, .jpeg" style={{"display": "none"}} onChange={(e:any)=>{if(e.target.files[0]!=null && e.target.files[0]!=undefined){setProfilePicture(e.target.files[0]);removeError('profilePicture')}}} />
                        <input type="hidden" name="avatar_remove" />
                        {/* <!--end::Inputs--> */}
                    </label>
                    {/* <!--end::Label--> */}
                </div>
                {/* <!--end::Image input--> */}
                {/* <!--begin::Hint--> */}
                <div className="form-text" id="validimage">Allowed file types: png, jpg, jpeg.</div>
                {/* <!--end::Hint--> */}
                <div className='text-danger fw-bold'>{error[0].profilePicture}</div>
            </div>
            {/* <!--end::Col--> */}
        </div>
        {/* <!--end::Input group--> */}
        {/* begin::Form group Firstname */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>Business name</label>
          <input
            placeholder='Business name'
            type='text'
            autoComplete='off'
            className='form-control bg-transparent'
            value={businessName}
            onChange={(e:any) => {setBusinessName(e.target.value);removeError("businessName");}}
          />
          <div className='text-danger fw-bold'>{error[0].businessName}</div>
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-8'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6'>Mobile Number</label>
          <PhoneInput
                  inputClass="form-control form-control-solid w-100"
                  placeholder='Enter Mobile Number'
                  enableSearch={true}
                  value={phoneNumber}
                  country={countryCode}
                  onChange={handleChange}
                />
          {/* end::Form group */}
          <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
        </div>

        {/* begin::Form group Email */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>Email</label>
          <input
            placeholder='Enter Email'
            type='email'
            autoComplete='off'
            className='form-control bg-transparent'
            value={email}
            onChange={(e:any) => {setEmail(e.target.value);removeError("email");}}
          />
          <div className='text-danger fw-bold'>{error[0].email}</div>
        </div>
        {/* end::Form group */}
        {/* begin::Form group Password */}
        <div className='fv-row mb-8' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>Password</label>
            <div className='position-relative mb-3'>
              <input
                type='password'
                placeholder='Password'
                autoComplete='off'
                className='form-control bg-transparent'
                value={password}
                onChange={(e:any) => {setPassword(e.target.value);removeError("password");}}
              />
              <div className='text-danger fw-bold'>{error[0].password}</div>
            </div>
            {/* begin::Meter */}
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
            {/* end::Meter */}
          </div>
          <div className='text-muted'>
            Use 8 or more characters with a mix of letters, numbers & symbols.
          </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label>
          <input
            type='password'
            placeholder='Password confirmation'
            autoComplete='off'
            className='form-control bg-transparent'
            value={confirmPassword}
            onChange={(e:any) => {setConfirmPassword(e.target.value);removeError("confirmPassword");}}
          />
          <div className='text-danger fw-bold'>{error[0].confirmPassword}</div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='text-center'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary w-100 mb-5'
            onClick={registrationApi}
          >
            <span className='indicator-label'>Submit</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_signup_form_cancel_button'
              className='btn btn-lg btn-light-primary w-100 mb-5'
            >
              Cancel
            </button>
          </Link>
        </div>
        {/* end::Form group */}
      </div>
    </div>
  )
}
